// extracted by mini-css-extract-plugin
export default {"tabLink":"TabContent_tabLink__JDVsh"};